
export function initTestimonials (selectorId) {
  const allTestimonials = document.querySelectorAll(`${selectorId} .destination-testimonials-item`);
  const allAuthorSlots = document.querySelectorAll(`${selectorId} .dyn-author-image`);
  
  if (!allTestimonials || allTestimonials.length === 0) {
  	console.error("No testimonials found");
	  return;
  }

  let currentIndex = 0;

  // Hide all testimonials initially
  allTestimonials.forEach((el) => el.style.display = "none");
  allAuthorSlots.forEach((slot) => {
    slot.style.display = "none";
    slot.classList.remove("active");
  });

  // Show initial
  function showTestimonial(index) {
    allTestimonials.forEach((el, i) => {
      el.style.display = i === index ? "block" : "none";
    });
    allAuthorSlots.forEach((slot, i) => {
      slot.classList.toggle("active", i === index);
    });
    currentIndex = index;
  }

  // Inject author images into slots
  const authors = [...allTestimonials];
  authors.forEach((testimonial, index) => {
    const imgUrl = testimonial.querySelector('.testimonial-card-author-image')?.src;
    const slot = document.querySelector(`${selectorId} [data-slot="${index+1}"]`);
    //const testimonialSlug = testimonial.dataset.slug;

    if (slot && imgUrl) {
	    slot.src = imgUrl;
      slot.style.display = "inline";
      if (index === 0) slot.classList.add("active");

      slot.addEventListener('click', () => {
        showTestimonial(index);
      });
    }
  });

  // Initial display
  showTestimonial(0);

  // Add navigation button logic
  const prevBtn = document.getElementById('destination-testimonials-btn-left');
  const nextBtn = document.getElementById('destination-testimonials-btn-right');

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const newIndex = (currentIndex - 1 + authors.length) % authors.length;
      showTestimonial(newIndex);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const newIndex = (currentIndex + 1) % authors.length;
      showTestimonial(newIndex);
    });
  }
}